import { Card } from '@/shared/ui/card';

interface PublicInviteInactiveProps {
  title?: string;
  description?: string;
}

/** Equivalente a views/cliente_inativo.ejs — loja com `client.inactive === true` (e fallback de "não encontrado"). */
export function PublicInviteInactive({
  title = 'Cadastro indisponível',
  description = 'Este programa de fidelidade não está disponível no momento.',
}: PublicInviteInactiveProps) {
  return (
    <Card className="mx-auto max-w-md p-8 text-center">
      <h1 className="text-xl font-semibold">{title}</h1>
      <p className="mt-2 text-sm text-muted-foreground">{description}</p>
    </Card>
  );
}
